import { axiosPrivate } from 'app/utils';
import helpers from './helpers';

export default {
  async getUserById(userId) {
    const response = await axiosPrivate.get(`/users/${userId}`);
    if (response.data.error) helpers.throwError(response.data.error);

    return {
      user: response.data.data[0],
    };
  },

  async checkUsernameExist(username) {
    const response = await axiosPrivate.post('/users/username/exists', { username });
    if (response.data.error) helpers.throwError(response.data.error);

    return response.data;
  },

  async updateUserById({ userId, payload }) {
    const response = await axiosPrivate.put(`/users/${userId}`, payload);
    if (response.data.error) helpers.throwError(response.data.error);

    return response.data;
  },

  async getUserClinicsByUserId({ userId }) {
    const resourceLink = `/v3/users/${userId}/clinics`;

    const { data } = await axiosPrivate.get(resourceLink);
    if (data.error) helpers.throwError(data.error);

    return data;
  },
};
